import {useEffect, useRef} from 'react';

export const useOnMount = (func?: VoidFunction, cleanup?: VoidFunction) => {
  const didMountRef = useRef(false);

  useEffect(function runOnMount() {
    if (cleanup !== undefined) {
      func?.();
      return cleanup;
    }

    if (didMountRef.current === false) {
      func?.();
      didMountRef.current = true;
    }

    return undefined;
  }, []);
};
